module.exports = __webpack_public_path__ + "static/media/pexels-brett-sayles-1000740.8ec586ff.jpg";